module.exports = __webpack_public_path__ + "img/portrait-011.4dc1a89b.jpg";